import { gql } from 'react-apollo';

export const createQuizMutation = gql`
  mutation createQuiz(
    $libraryId: Int!
    $title: String!
    $content: JSONString!
    $questionIds: String!
    $autoCreateContent: Boolean
    $subjectId: Int
    $unitId: Int
    $subunitId: Int
    $educationPeriod: Int
    $quizType: String
  ) {
    createQuiz(
      libraryId: $libraryId
      title: $title
      content: $content
      questionIds: $questionIds
      autoCreateContent: $autoCreateContent
      subjectId: $subjectId
      unitId: $unitId
      subunitId: $subunitId
      educationPeriod: $educationPeriod
      quizType: $quizType
    ) {
      ok
      itemId
      message
    }
  }
`;

export const deleteQuizMutation = gql`
  mutation deleteQuiz($itemId: Int!) {
    deleteQuiz(itemId: $itemId) {
      deleted
      message
    }
  }
`;

export const copyItemAndCreateItemShareMutation = gql`
  mutation copyItemAndCreateItemShar(
    $itemId: Int!
    $subjectId: Int!
    $shareKey: String
    $title: String
    $shouldCreateItemShareOnly: Boolean
    $itemShareId: Int
  ) {
    copyAssessment(
      assessmentId: $itemId
      subjectId: $subjectId
      shareKey: $shareKey
      title: $title
      shouldCreateItemShareOnly: $shouldCreateItemShareOnly
      itemShareId: $itemShareId
    ) {
      ok
      message
      newAssessment {
        itemShareInfo {
          itemId
          title
          createdDate
          sharedDate
          createdBy
          teacherQuestions
          status
        }
      }
    }
  }
`;

export const deleteItemShareMutation = gql`
  mutation deleteItemShare($id: Int!) {
    deleteItemShare(id: $id) {
      isDeleted
    }
  }
`;

export const updateQuizDescriptionMutation = gql`
  mutation updateQuizDescription($item_id: Int!, $description: String!) {
    updateQuizDescription(itemId: $item_id, description: $description) {
      ok
    }
  }
`;

export const updateItemShareActiveMutation = gql`
  mutation updateItemShareActive($oldItemId: Int!, $status: String) {
    updateItemShareActive(oldItemId: $oldItemId, status: $status) {
      ok
    }
  }
`;
